import type { ScreenOption } from '../types';

/**
 * The screens an internal link (`screen:` ref, spec §4.3) may target,
 * tracked per app the same launch-simple way PreviewSkins tracks page
 * chrome: a short admin-side registry, resolved by the app being edited.
 * Keyed by the core-db `AppType` — the code-level identity of the app,
 * stable across environments — never by App id (a per-environment UUID).
 *
 * Each list must stay in lockstep with that app's screen resolver (the
 * other half of the contract — membership: ContentSlot `SCREEN_ROUTES`).
 * Keys are append-only: retire a screen by removing it HERE (so new
 * actions can't target it) while the app keeps resolving it, so
 * already-published content never goes inert. Replaced by a
 * machine-readable per-app screen manifest post-launch (spec §8).
 */
const APP_SCREENS: Record<string, ScreenOption[]> = {
  MEMBERSHIP_PORTAL: [
    { ref: 'screen:private-dining', label: 'Private Dining' },
    { ref: 'screen:shop', label: 'Shop' },
    { ref: 'screen:ticketed-events', label: 'Ticketed Events' },
    { ref: 'screen:venues', label: 'Venues' },
  ],
};

/** Unknown/absent app type = no internal screens offered in the picker. */
export function getAppScreens(appType?: string): ScreenOption[] {
  return appType ? (APP_SCREENS[appType] ?? []) : [];
}
